<header matDialogTitle>
  <div>{{ mode() }} top of book source</div>
  <button mat-icon-button color="primary" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</header>
<ng-container
  *ngrxLet="{
    isLpType: isLpType$,
    isSourceType: isSourceType$,
    firstSourceName: firstSourceName$,
    secondSourceName: secondSourceName$,
    isAggregateType: isAggregateType$,
    sources: sources$,
    lpPairs: lpPairs$,
  } as params"
>
  <form [formGroup]="form" matDialogContent>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Source type</mat-label>
        <mat-select disableOptionCentering formControlName="type">
          @for (type of sourceTypes(); track type) {
            <mat-option [value]="type.value">{{ type.description }} </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput type="text" formControlName="name" />
      </mat-form-field>
    </div>
    @if (params.isLpType) {
      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Liquidity Provider</mat-label>
          <mat-select disableOptionCentering formControlName="lpId">
            @for (lp of lps(); track lp) {
              <mat-option [value]="lp.id">{{ lp.name }} </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    <app-pair-selector
      [options]="params.isLpType ? params.lpPairs : basePairs()"
      formControlName="pair"
    ></app-pair-selector>

    <div class="row">
      @if (params.isSourceType) {
        <app-source-selector
          [label]="params.firstSourceName"
          [options]="params.sources"
          formControlName="source1"
        ></app-source-selector>
      }
      @if (params.isAggregateType) {
        <mat-form-field appearance="outline" class="weight-input">
          <mat-label>Weight 1</mat-label>
          <input matInput type="text" formControlName="weight1" />
        </mat-form-field>
      }
    </div>

    <div class="row">
      @if (params.isSourceType) {
        <app-source-selector
          [label]="params.secondSourceName"
          [options]="params.sources"
          formControlName="source2"
        ></app-source-selector>
      }
      @if (params.isAggregateType) {
        <mat-form-field appearance="outline" class="weight-input">
          <mat-label>Weight 2</mat-label>
          <input matInput type="text" formControlName="weight2" />
        </mat-form-field>
      }
    </div>

    @if (params.isAggregateType) {
      <div class="row">
        <app-source-selector
          label="Source 3"
          [options]="params.sources"
          formControlName="source3"
        ></app-source-selector>
        <mat-form-field appearance="outline" class="weight-input">
          <mat-label>Weight 3</mat-label>
          <input matInput type="text" formControlName="weight3" />
        </mat-form-field>
      </div>
      <div class="row">
        <app-source-selector
          label="Source 4"
          [options]="params.sources"
          formControlName="source4"
        ></app-source-selector>
        <mat-form-field appearance="outline" class="weight-input">
          <mat-label>Weight 4</mat-label>
          <input matInput type="text" formControlName="weight4" />
        </mat-form-field>
      </div>
    }

    <div class="row">
      <mat-checkbox color="primary" formControlName="enabled" class="form-checkbox">Enabled </mat-checkbox>
    </div>
  </form>
</ng-container>
<div matDialogActions>
  <button
    (click)="update()"
    [disabled]="form.invalid || form.pristine"
    mat-raised-button
    color="primary"
    type="button"
    matDialogClose
  >
    {{ mode() }}
  </button>
  <button mat-button type="button" color="primary" matDialogClose>Cancel</button>
</div>
